import {ManagementAssignmentsSelection} from 'constants'
import {UserTeamAssignmentType} from '../constants'

export const DEFAULT_MANAGEMENT_ASSIGNMENTS = {
    managementAssignmentsSelection: ManagementAssignmentsSelection.SELECTED,
    addedTaskIds: [],
    addedProjectIds: [],
    addedProjectIdsExcludingSelf: [],
    addedCustomerIds: [],
    addedCustomerIdsExcludingSelf: [],
}

export const DEFAULT_TEAM_ASSIGNMENTS = {
    teamAssignmentType: UserTeamAssignmentType.SELECTED,
    assignedGroups: [],
    assignedUsers: [],
}


// WEBPACK FOOTER //
// ./web/js/panels/user/createPanel/constants.js